import React from 'react';
import {useSelector} from 'react-redux';

import {COLUMNS} from '../../constants';
import {useGetUserConferencesConference} from '../../hooks/useGetUserConferencesConference';
import {userConferencesResultSelector} from '../../slices/user-conferences.slice';

import {HeaderCaption} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';


type Props = {
    accountIds: number[],
    totalCount: number,
};

const ConferenceEndsHeaderController = ({accountIds, totalCount}: Props) => {
    const {isLoading, loadingError} = useGetUserConferencesConference({
        accountIds,
        totalCount,
        columnId: COLUMNS.CONFERENCE_END_DATE,
    });

    return (
        <HeaderCaption
            isLoading={isLoading}
            loadingError={loadingError}
            columnId={COLUMNS.CONFERENCE_END_DATE}
        />
    );
};

export const ConferenceEndsHeader = () => {
    const result = useSelector(userConferencesResultSelector);

    return result ? (
        <ConferenceEndsHeaderController
            accountIds={result.data.map(({accountId}) => accountId)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.CONFERENCE_END_DATE}/>
    );
};
